
export const SMS_MSISDN_KEY = 'msisdn'
export const SMS_ORIGIN_KEY = 'o'
export const SMS_OFFER_KEY = 'offer_id'
export const SMS_STORE_MSISDN_KEY = 'sms_msisdn'
export const SMS_STORE_ORIGIN_KEY = 'sms_origin'
export const SMS_STORE_OFFER_KEY = 'sms_offer'
export const SMS_STORE_TELEVENDAS_ID_KEY = 'televendas_id'
export const SMS_PEDIDO_VENDA_ID_KEY = 'pvid'
export const SMS_STORE_PEDIDO_VENDA_ID_KEY = 'pedido_venda_id'

export const BEAUTH_CODE = 'code'
export const CHANNEL_KEY = 'channel'
export const CPF_KEY = 'cpf'

export const SHOULD_SAVE_MSISDN_AND_RECORD_ACTIONS = 'should_save_msisdn_and_record_actions'
export const SHOULD_HIDE_BACK_BUTTONS = 'should_hide_back_buttons'
export const SHOULD_HIDE_SWITCH_OFFER = 'should_hide_switch_offer'

export const CURRENT_OFFER_KEY = 'current_offer'
